import { makeStyles } from '@material-ui/core/styles'
import { FilterBackground, FilterBorder } from '../../../../utils/colors'

export const useStyles = makeStyles((theme) => ({
  formWrapper: {
    position: 'relative'
  },
  AdditionalInfoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      minWidth: 170,
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        paddingRight: theme.spacing(2)
      }
    },
    '& .MuiFormControl-root': {
      width: 340,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxWidth: 340
      }
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  NationalIdRow: {
    display: 'flex',
    alignItems: 'flex-start',
    flex: '1 1 auto',
    gap: `${theme.spacing(1)}px`
  },
  NationalIdVerifyButtonWrapper: {
    marginTop: `${theme.spacing(1)}px`,
    display: 'flex',
    alignItems: 'center',
    gap: `${theme.spacing(1)}px`,
    '& button': {
      height: 40
    }
  },
  AdditionalInfoPhoneRow: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.only('sm')]: {
      width: 340,
      maxWidth: '100%'
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-end'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  PhoneInputWrapper: {
    direction: theme.direction === 'ltr' ? 'ltr' : 'rtl',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    '& .react-tel-input': {
      fontFamily: 'inherit'
    },
    '& .react-tel-input .form-control': {
      width: 340,
      paddingTop: theme.spacing(1.375),
      paddingBottom: theme.spacing(1.125),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0.5),
      '&[disabled]': {
        backgroundColor: theme.palette.secondary.main
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    '& .country-list': {
      direction: 'ltr',
      textAlign: 'left',
      '& .search': {
        paddingLeft: theme.spacing(1.25)
      },
      '& .search-box': {
        marginLeft: theme.spacing(1)
      },
      '& .country-name': {
        marginRight: theme.spacing(1)
      },
      '& .dial-code': {
        direction: theme.direction === 'ltr' ? 'ltr' : 'rtl',
        textAlign: 'right',
        display: 'inline-block'
      }
    }
  },
  EmailWrapper: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto'
  },
  VerifiedIcon: {
    color: theme.palette.success.main,
    marginLeft: theme.spacing(1),
    fontSize: theme.typography.pxToRem(28)
  },
  SubmitRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(4, 0, 0)
  },
  AdditionalInfoSubmit: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 120
    }
  },
  ChangePhoneDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    background: FilterBackground,
    border: `1px solid ${FilterBorder}`,
    '& .MuiTypography-root': {
      color: theme.palette.primary.light,
      fontWeight: theme.typography.fontWeightBold
    }
  },
  ChangePhoneDialogPaper: {
    borderRadius: 0,
    overflow: 'visible'
  },
  ChangePhoneDialogContent: {
    padding: '0 !important',
    position: 'relative',
    overflow: 'visible'
  },
  ChangePhoneDialogClose: {
    position: 'absolute',
    zIndex: 10,
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.dark
  },
  ChangePhoneDialogFooter: {
    padding: theme.spacing(2)
  },
  changePhoneButton: {
    color: theme.palette.primary.light,
    background: 'transparent',
    border: 'none',
    marginLeft: theme.spacing(2)
  },
  changeLinkButton: {
    color: theme.palette.primary.light,
    background: 'transparent',
    border: 'none',
    padding: 0,
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: 'inherit',
    fontFamily: 'inherit'
  },
  ChangePhoneVerifyWrapper: {
    whiteSpace: 'pre-line',
    textAlign: 'center'
  },
  ChangePhoneVerify: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      minWidth: 170,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        margin: 0,
        paddingRight: theme.spacing(2)
      }
    },
    '& .MuiFormControl-root': {
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    }
  },
  captchaWrapper: {},
  captchaRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(1)
  },
  captchaContainer: {
    position: 'relative',
    minWidth: 200,
    minHeight: 60,
    '&.loading': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  captchaGenerateBtn: {}
}))
